<template>
  <div class="container">
    <h3 class="title">Dane nie zostały odnalezione.</h3>
    <div class="btn-group">
      <a :href="`tel:${$phone}`" class="btn" :style="{ background: $color }">Telefon</a>
      <button type="button" class="btn" :style="{ background: $color }" @click="setHomePage">Menu</button>
      <button
        type="button"
        class="btn"
        :style="{ background: $color }"
        @click="editPesel"
      >Popraw dane</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "AssistanceNoResult",
  methods: {
    ...mapMutations([
      "setAssistanceStep",
      "setHomePage",
      "setPesel",
      "setUserData",
    ]),
    editPesel() {
      this.setPesel("");
      this.setUserData({ PhoneNumber: "" });
      this.setAssistanceStep(this.steps[0].value);
    },
  },
  computed: {
    ...mapState(["steps"]),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/NoResult.vue